import React from 'react';
import ContentPage from '../components/ContentPage';

export default function HowItWorksPage() {
  return (
    <ContentPage
      pageId="comment-ca-marche"
      relatedLinks={[
        { to: '/menus', label: 'Voir les menus de saison' },
        { to: '/tarifs', label: 'Voir les tarifs de préparation de repas à domicile' },
        { to: '/services-a-la-personne', label: 'Découvrir le crédit d\u2019impôt de 50 %' },
        { to: '/zone-intervention', label: 'Consulter notre zone d\u2019intervention' },
      ]}
    />
  );
}
